"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSemanticTextComponent = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _utils = require("../utils");

var _Text = _interopRequireDefault(require("./Text"));

var createSemanticTextComponent = function createSemanticTextComponent(tag, defaultProps) {
  // Capitalize the first letter of the tag name
  var componentName = "".concat(tag.charAt(0).toUpperCase()).concat(tag.substr(1));

  var HeadingComponent = _Text.default.withComponent(tag, {
    target: "e16nynr70"
  });

  HeadingComponent.defaultProps = (0, _objectSpread2.default)({}, _Text.default.defaultProps, defaultProps);
  var DocumentedHeadingComponent = (0, _stencilReactDesc.describe)(HeadingComponent).description("Text with ".concat(tag, " tag"));
  DocumentedHeadingComponent.propTypes = (0, _objectSpread2.default)({}, _Text.default.describedPropTypes);
  var ComponentWithTestAttributes = (0, _utils.withTestAttributes)({
    component: "Stencil".concat(componentName)
  })(DocumentedHeadingComponent);
  ComponentWithTestAttributes.displayName = componentName;
  return ComponentWithTestAttributes;
};

exports.createSemanticTextComponent = createSemanticTextComponent;